import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TicketViewer } from './TicketViewer';
import { TicketList } from './TicketList';
import { Tags } from '../tag/Tags';
import {
	TicketItem,
    //addTickets,
    //AddNotesAction,
  	selectTickets,
} from './ticketSlice';

export function TicketBrowser() {
	return (
		<LargeTicketBrowser />
	);
}

export function LargeTicketBrowser() {
	const viewStyle = {
		height: `calc(100%)`,
		//backgroundColor: 'purple',
	};
	const mainStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		//backgroundColor: 'pink',
	};
	const contentStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		display: 'flex',
		//backgroundColor: 'red',
	};
	const colOneStyle = {
		height: '100%',
		flexGrow: 4,
	};
	const colTwoStyle = {
		height: '100%',
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};

	const leftPaneOpen = true;

	return (
		<Box sx={viewStyle}>
				<Box sx={mainStyle}>
					<Box sx={contentStyle}>
							<Outlet />
					</Box>
				</Box>
		</Box>
	);
}
